// payment/payment.types.ts
var PaymentMethod = /* @__PURE__ */ ((PaymentMethod2) => {
  PaymentMethod2["CASH"] = "cash";
  PaymentMethod2["ACH"] = "ach";
  return PaymentMethod2;
})(PaymentMethod || {});

export {
  PaymentMethod
};
